import { render } from "./setting-student-subscription.vue?vue&type=template&id=6fb0baf6"
import script from "./setting-student-subscription.vue?vue&type=script&lang=js"
export * from "./setting-student-subscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__